/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const TenantCourseStatisticsParser = 
/* #__PURE__ */ parsers.object([
    ['total', codecNumber],
    ['active', codecNumber],
]);
export class TenantCourseStatistics extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TenantCourseStatisticsParser.decode(input).map(res => new TenantCourseStatistics(res));
    }
    static unsafeDecode(input) {
        return TenantCourseStatistics.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TenantCourseStatisticsParser.encode(data);
    }
    static schema() {
        return TenantCourseStatisticsParser.schema();
    }
}
